import { useOpenAsset } from '../../../../data/assets/helpers';
import { ACTION_CONFIGS } from './interfaces';

/**
 * Hook that returns a dispatcher function for each action type, which can be used to execute the corresponding action.
 * @returns
 */
export function useActionDispatcher() {
  const openAsset = useOpenAsset();

  // Returns a dictionary of executable functions
  return {
    [ACTION_CONFIGS.OPEN_ASSET.type]: (val: string) => openAsset(val),
  };
}
